import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/google_play_store.svg")